import React, { useContext, useRef } from 'react';
import { View, Heading } from '@fairygodboss/ui';
import { useEventRegistration } from '../EventRegistrationContext';
import SocialShareBarV2 from '../../../CallToAction/SocialShareBarV2/SocialShareBarV2';
import { PageContext } from '../../../../contexts/ContextCreator';

export const SocialShareCta = ({ showLabel, alwaysDisplay, styles }) => {
    const displayRef = useRef();
    const {
        eventEnded,
        registrationExpired,
        event,
        eventStarted,
        userRegistered,
        videoRef,
    } = useEventRegistration();
    const {
        pageProps: { url },
    } = useContext(PageContext);
    const { registrationDeactivated, eventType } = event;

    if (
        eventType === 'Webinar' &&
        eventEnded &&
        !videoRef?.current &&
        !alwaysDisplay
    ) {
        return null;
    }
    if (eventType === 'Virtual Recruiting Event') {
        if (
            registrationDeactivated ||
            registrationExpired ||
            (!userRegistered && eventStarted) ||
            eventEnded
        ) {
            return null;
        }
        if (
            userRegistered &&
            eventStarted &&
            !eventEnded &&
            !registrationExpired
        ) {
            return null;
        }
    }

    return (
        <View ref={displayRef}>
            {showLabel ? (
                <Heading
                    pt="12px"
                    display={{ _: 'none', md: 'inherit' }}
                    variant="headingXs"
                    fontWeight="700"
                    mb="16px"
                >
                    Share
                </Heading>
            ) : null}
            <View width="147px" {...styles}>
                <View id="shareID" justifyContent={{ _: 'start', md: 'end' }}>
                    <SocialShareBarV2
                        hash={event.hash}
                        type={event.type}
                        urlToShare={`${url?.host}${event?.viewUrl}`}
                    />
                </View>
            </View>
        </View>
    );
};
